import enAU from 'date-fns/esm/locale/en-AU';

const dateEnAu = {
    name: 'en-AU',
    locale: enAU
};
export default dateEnAu;
